const pageVisibilityMap = {
  public: 'public',
  private: 'private',
}

export default pageVisibilityMap
